import { useEffect, useRef } from 'react';

export function useAiUrl(id: string | undefined) {
  const recentUrl = useRef<string>();
  useEffect(() => {
    if (!window.location.href.includes(`/wb/actionitem`)) {
      // store previous URL
      recentUrl.current = window.location.href;
    }

    const timeout = setTimeout(() => {
      const url = window.location.href;

      if (url.includes('id=-1')) {
        const newUrl = url.replace('id=-1', `id=${id}`);
        window.history.pushState({}, null, newUrl);
        return;
      }

      if (id && !url.includes(`id=${id}`)) {
        // redirects to the AI url
        const newUrl = new URL(window.location.href);
        newUrl.pathname = `/wb/actionitem`;
        newUrl.search = new URLSearchParams({
          id,
        }).toString();
        window.history.pushState({}, null, newUrl.href);
      }

      // Wait until window.location.href gets updated with id=-1
    }, 200);

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
      if (recentUrl.current) {
        // restore previous URL
        window.history.pushState({}, null, recentUrl.current);
      }
    };
  }, [id]);
}
